import React from 'react';
import { Col, Form } from 'antd';

import { WorkstationSelect } from '@/components/ui/Inputs/WorkstationSelect';
import { useApplicationContext } from '@/context/v1/Application/context';
import { useWorkstations } from '@/hooks/v1';
import FormItem from '@/components/ui/FormItem';

const { useFormInstance, useWatch } = Form;

interface WorkstationsProps {
	disabled?: boolean;
	onValueChange: (changed: boolean) => void;
}

export function Workstations({ disabled = false, onValueChange }: Readonly<WorkstationsProps>): JSX.Element {
	const form = useFormInstance();
	const { company, organization } = useApplicationContext();

	const lineId = useWatch('line_id', form);
	const workstationId = useWatch('workstation_id', form);

	const {
		data: workstations,
		isLoading,
		isFetching,
		isError
	} = useWorkstations({
		organization_id: organization?.id,
		company_id: company?.id,
		line_id: lineId
	});

	function handleWorkstationSelect(id: string) {
		onValueChange(true);
		form.setFieldValue(['workstation_id'], id);
	}

	function handleClearWorkstations() {
		form.setFieldValue(['workstation_id'], undefined);
	}

	return (
		<Col xs={24} sm={12}>
			<FormItem
				name={['workstation_id']}
				label="Workstation"
				labelCol={{ span: 24 }}
				requiredMessage="Select the workstation"
				required
			>
				<WorkstationSelect
					size="large"
					lineId={lineId}
					loading={isFetching}
					fieldName="workstation_id"
					workstations={workstations}
					workstationId={workstationId}
					handleSelectWorkstation={handleWorkstationSelect}
					handleClearWorkstations={handleClearWorkstations}
					disabled={disabled || isLoading || isFetching || isError || !lineId}
				/>
			</FormItem>
		</Col>
	);
}
